import { render, staticRenderFns } from "./LimsMenu.vue?vue&type=template&id=4745e1df&scoped=true&"
import script from "./LimsMenu.vue?vue&type=script&lang=js&"
export * from "./LimsMenu.vue?vue&type=script&lang=js&"
import style0 from "./LimsMenu.vue?vue&type=style&index=0&id=4745e1df&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4745e1df",
  null
  
)

export default component.exports